import type { Location } from 'react-router-dom';

export function pathFromLocationState(state: unknown): string | null {
  if (!state || typeof state !== 'object' || !('from' in state)) {
    return null;
  }
  const from = (state as { from?: Pick<Location, 'pathname' | 'search'> }).from;
  if (!from?.pathname || from.pathname === '/login' || from.pathname === '/signup') {
    return null;
  }
  return `${from.pathname}${from.search || ''}`;
}
